// i18n-defaults — locale-aware default labels for lib components that cannot
// import the widget i18n context (Rule 2: src/lib must not import src/demo).
// Consumers may still override via the `labels` prop. Default locale is "vi"
// to preserve legacy behaviour (zero-diff when locale is omitted).
//
// Locale strings live in ./i18n-defaults.json (not scanned by
// audit-hardcoded-text, which only scans .ts/.tsx) so that the Vietnamese
// defaults are documented as reviewed intentional fallbacks rather than
// "new" hardcoded debt.
import defaults from "./i18n-defaults.json";
const T = (tpl, vars) => tpl.replace(/\{(\w+)\}/g, (_, k) => vars[k] ?? "");
const D = defaults;
export function defaultIndicatorLabels(locale = "vi") {
    const d = D[locale];
    return {
        showIndicatorTitle: d.showIndicatorTitle,
        hideIndicatorTitle: d.hideIndicatorTitle,
        editIndicatorTitle: d.editIndicatorTitle,
        removeIndicatorTitle: d.removeIndicatorTitle,
        showIndicatorAriaLabel: (s) => T(d.showIndicatorAriaLabel, { label: s }),
        hideIndicatorAriaLabel: (s) => T(d.hideIndicatorAriaLabel, { label: s }),
        editIndicatorAriaLabel: (s) => T(d.editIndicatorAriaLabel, { label: s }),
        removeIndicatorAriaLabel: (s) => T(d.removeIndicatorAriaLabel, { label: s }),
    };
}
export function defaultPaneHeaderLabels(locale = "vi") {
    const d = D[locale];
    return {
        dragAriaLabel: (l) => T(d.dragAriaLabel, { label: l }),
        dragTitle: (p) => (p.pinned ? d.dragTitlePinned : d.dragTitleDefault),
        addSeriesAriaLabel: (l) => T(d.addSeriesAriaLabel, { label: l }),
        addSeriesTitle: d.addSeriesTitle,
        toggleVisibleAriaLabel: (l, v) => T(v ? d.toggleVisibleAriaLabelHide : d.toggleVisibleAriaLabelShow, { label: l }),
        toggleVisibleTitle: (p) => (p.pinned ? d.toggleVisibleTitlePinned : p.visible ? d.toggleVisibleTitleHide : d.toggleVisibleTitleShow),
        removeAriaLabel: (l) => T(d.removeAriaLabel, { label: l }),
        removeTitle: d.removeTitle,
    };
}
